export const USER_ID_STORAGE_KEY = 'user-id'
export const CAR_TOOL_SESSION_STORAGE_KEY = 'car-tool-session'
export const CAR_TOOL_UI_STATE_STORAGE_KEY = 'car-tool-ui-state'
